import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Grid,
  Menu,
  MenuItem,
  useTheme,
  IconButton,
  DialogContent,
  InputLabel,
  DialogContentText,
} from "@material-ui/core";
import Header from "../layouts/Header";
import TextField from "../MuiComponent/TextField";
import useGeneralStyle from "../assets/css/general";
import { useFormik } from "formik";
import { addServiceValidation } from "../validations/login-validate";
import { httpClient } from "../config/httpClient";
import useCallbackStatus from "../hooks/useCallbackStatus";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import Datatable from "../MuiComponent/Datatable";
import _ from "lodash";
import ConfirmationModal from "../MuiComponent/ConfirmationModal";
import { useHistory } from "react-router-dom";
import DetailView from "./DetailView";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import moment from "moment";
import Modal from "../MuiComponent/Modal";
import { Autocomplete } from "@material-ui/lab";
import Invoice from "./invoice/Invoice";
import Composition from "./invoice/Composition";
import { useAuth } from "../providers/AuthProvider";
import HasBusinessDetailsCheck from "../components/HasBusinessDetailsCheck";

const tableHeader = [
  { id: "name", align: "left", label: "DATE & TIME", minWidth: 170 },
  {
    id: "size",
    label: "NAME",
    minWidth: 170,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "ACTIVE",
    minWidth: 170,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "density",
    label: "VIEW",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    id: "density",
    label: "ACTION",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
];

const useStyles = makeStyles((theme2) => ({
  root: {
    width: "100%",
    marginTop: "25px",
    overflowX: "auto",
    backgroundColor: "white",
    border: "1px solid #caced5",
  },
  container: {
    height: "440px",
    width: "100%",
  },
  inputLabel: {
    color: "color",
    fontSize: "13px",
    padding: "10px 0px",
  },
  activeFilter: {
    backgroundColor: theme2.palette.primary.main,
    color: "white",
    fontWeight: 600,
  },
}));

function ServiceManagement() {
  const classes = useStyles();
  let history = useHistory();
  const auth = useAuth();
  const [page, setPage] = React.useState(0);
  const [modalStatus, setModalStatus] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [users, setPOSUserList] = useState([]);
  const [mode, setMode] = useState("add");
  const [view, setView] = useState("false");
  const notification = useSnackbar();
  const [confirmation, setConfirmation] = React.useState(false);
  const addSliderApiStatus = useCallbackStatus();
  const [search, setSearchKey] = useState("");
  const getBannersApiStatus = useCallbackStatus();
  const [filter, setFilter] = useState("pending");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [data, setData] = React.useState([]);
  const [totalPages, setTotalPages] = React.useState(10);
  const [modal, setModal] = React.useState(false);
  const globalClasses = useGeneralStyle();
  const [businessCheck, setBusinessCheck] = useState(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [orderDetail, setOrderDetail] = useState({});

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const theme = useTheme();

  const fileHandler = (file, alt) => {
    if (file && file !== "") {
      console.log("coming in if condition.", file);
      setValues({ ...values, image_name: file.name, image: file });
    }
  };

  //   const getCategories = async () => {
  //     const apiBody = {
  //       pagination_required: true,
  //     };

  //     await getCategoryListStatus.run(
  //       httpClient("POST", "/common/category", {
  //         body: apiBody,
  //       }).then((result) => {
  //         console.log("Result: ", result);

  //         const { data } = result;

  //         setCategoriesList(data);
  //       })
  //     );
  //   };

  const fetchData = async (pageSize = 10, pageNumber = 1) => {
    await getBannersApiStatus.run(
      httpClient(
        "GET",
        `/partner/listServices?page_size=${pageSize}&type=partner&page=${pageNumber}&search_string=${search}&status=${filter}&pagination_required: true&status=completed&business_id=${auth.userData.business_id}`,
        {
          body: {},
        }
      ).then((result) => {
        const {
          data: { data, meta },
        } = result;

        setData(data);
        setTotalPages(meta.total);
      })
    );
  };

  //   const fetchData = async (pageSize = 10, pageNumber = 1) => {
  //     const apiBody = {
  //       page: pageNumber,
  //       pageSize: pageSize,
  //       type: "admin",
  //       search_string: search,
  //     };

  //     if (apiBody.search_string === "") {
  //       delete apiBody.search_string;
  //     }

  //     await addSliderApiStatus.run(
  //       httpClient("POST", "/admin/listServices", {
  //         body: apiBody,
  //       }).then((result) => {
  //         const {
  //           data: { data, total },
  //         } = result;

  //         setPOSUserList(data);
  //         console.log("Result: ", result, data);
  //       })
  //     );
  //   };

  const editBanner = async () => {
    let fd = new FormData();
    fd.append("id", values.id);
    fd.append("name", values.name);
    fd.append("link", values.link);
    fd.append("active", values.active);
    fd.append("type", values.type);

    if (typeof image == "object") fd.append("image", values.image);

    await addSliderApiStatus.run(
      httpClient("POST", "/admin/updateSlider", {
        body: fd,
      })
        .then((result) => {
          console.log("Result: ", result);
          resetForm();
          setModal(false);

          //   getSliders();

          notification.enqueueSnackbar("Slider Updated Successfully", {
            variant: "success",
          });
        })
        .catch((er) => {
          console.log("Error: ", er);

          notification.enqueueSnackbar(er.errors["name"], {
            variant: "error",
          });
        })
    );
  };

  const deleteBanner = async () => {
    await addSliderApiStatus.run(
      httpClient("POST", "/admin/deleteSlider", {
        body: {
          id: values.id,
        },
      })
        .then((result) => {
          console.log("Result: ", result);
          resetForm();
          setConfirmation(false);
          //   getSliders();

          notification.enqueueSnackbar("Slider Deleted Successfully", {
            variant: "success",
          });
        })
        .catch((er) => {
          console.log("Error: ", er);

          notification.enqueueSnackbar(er.errors["name"], {
            variant: "error",
          });
        })
    );
  };

  const addData = async () => {
    await addSliderApiStatus.run(
      httpClient("POST", "/partner/services", {
        body: {
          name: values.name,
          category: "Electricals",
          type: values.type,
        },
      })
        .then((result) => {
          console.log("Result: ", result);
          resetForm();
          setModalStatus(!modalStatus);

          fetchData();

          notification.enqueueSnackbar("Service Added Successfully", {
            variant: "success",
          });
        })
        .catch((er) => {
          console.log("Error: ", er);

          notification.enqueueSnackbar(er.errors["name"], {
            variant: "error",
          });
        })
    );
  };

  let {
    values,
    touched,
    errors,
    setValues,
    resetForm,
    handleBlur,
    submitForm,
    handleChange,
  } = useFormik({
    initialValues: {
      name: "",
      status: "active",
    },
    onSubmit: () => {
      //   if (mode == "edit") editBanner();
      //   else if (mode == "delete") deleteBanner();
      // else
      addData();
    },
    validationSchema:
      //   mode == "edit" || mode == "delete"
      //     ? editSliderValidation
      // :
      addServiceValidation,
  });

  //   useEffect(() => {
  //     getCategories();
  //   }, []);

  //   useEffect(() => {
  //     const delayDebounceFn = setTimeout(() => {
  //       fetchData();
  //     }, 300);

  //     return () => clearTimeout(delayDebounceFn);
  //   }, [mobileNumber]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [search, filter]);

  const ModalHeader = () => {
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          style={{ fontSize: "14px" }}
        >
          <Box textAlign="left" style={{ fontWeight: 600 }} padding={1}>
            Add Service
          </Box>
          <IconButton
            style={{ position: "absolute", right: "20px" }}
            onClick={() => {
              setModalStatus(!modalStatus);
            }}
          >
            <CloseIcon size="small" />
          </IconButton>
        </Box>
      </>
    );
  };

  return (
    <>
      <HasBusinessDetailsCheck
        status={businessCheck}
        onClose={() => {
          if (_.isNull(auth.userData?.businessDetails?.account_details))
            history.push("/profile/account-details");
          else history.push("/profile/business-details");
        }}
      />
      <Modal
        headerComponent={ModalHeader}
        height="340px"
        // buttonAlign="center"
        width="100%"
        closeBtnText="Cancel"
        saveBtnText="Proceed"
        // loading={actionApiStatus.isPending}
        saveHandler={() => {
          submitForm();
        }}
        closeHandler={() => {
          setModalStatus(!modalStatus);
        }}
        status={modalStatus}
      >
        <DialogContentText id="alert-dialog-description">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box display="flex" flexDirection="column">
                <InputLabel className={globalClasses.inputLabel}>
                  Name
                </InputLabel>
                <TextField
                  id="name"
                  name="name"
                  error={touched.name && errors.name}
                  helperText={touched.name && errors.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  inputProps={{
                    style: { padding: "12px", backgroundColor: "white" },
                  }}
                  FormHelperTextProps={{ style: { fontSize: "10px" } }}
                  placeholder="write here"
                  variant="outlined"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <InputLabel className={globalClasses.inputLabel}>
                  Status
                </InputLabel>
                <TextField
                  id="status"
                  name="status"
                  error={touched.status && errors.status}
                  helperText={touched.status && errors.status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.status}
                  inputProps={{
                    style: { padding: "12px", backgroundColor: "white" },
                  }}
                  FormHelperTextProps={{ style: { fontSize: "10px" } }}
                  placeholder="write here"
                  variant="outlined"
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContentText>
      </Modal>

      <ConfirmationModal
        height="150px"
        width="auto"
        title="Are you sure"
        status={confirmation}
        closeBtnText="cancel"
        saveBtnText="Delete"
        closeHandler={() => setConfirmation(!confirmation)}
        saveHandler={() => submitForm()}
      >
        Are you sure want to delete this category
      </ConfirmationModal>

      <Header>
        <Typography style={{ flexGrow: 1 }} variant="h6" noWrap>
          Service Management
        </Typography>
      </Header>

      {view == "false" ? (
        <>
          <Grid container style={{ padding: theme.spacing(3) }}>
            <Grid
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 0px",
              }}
              item
              xs={5}
            >
              <Box style={{ paddingRight: "20px" }}>Search</Box>
              <TextField
                onChange={(e) => setSearchKey(e.target.value)}
                variant="outlined"
                style={{ width: "100%" }}
                inputProps={{
                  style: { padding: "12px", backgroundColor: "white" },
                }}
                placeholder="by order ID, name, email"
              />
            </Grid>
            <Grid
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row-reverse",
                padding: "10px 0px",
              }}
              item
              xs={7}
            >
              <Button
                onClick={() => {
                  if (
                    _.isNull(auth.userData.businessDetails) ||
                    _.isNull(auth.userData?.businessDetails?.account_details)
                  )
                    setBusinessCheck(true);
                  else {
                    history.push("/tasks/add");
                  }
                }}
                variant="contained"
                color="primary"
              >
                Add Service
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.root}>
                <Datatable
                  getDataList={fetchData}
                  totalRecords={totalPages}
                  loading={getBannersApiStatus.isPending}
                  tableHeader={tableHeader}
                >
                  {data.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          {moment(item.updated_at).format(
                            "DD MMM YYYY, hh:mm A"
                          )}
                        </TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.category}</TableCell>
                        <TableCell>{item.status}</TableCell>
                        <TableCell>
                          <PopupState
                            variant="popover"
                            popupId="demo-popup-menu"
                          >
                            {(popupState) => (
                              <React.Fragment>
                                <IconButton {...bindTrigger(popupState)}>
                                  <MoreHorizIcon />
                                </IconButton>
                                <Menu {...bindMenu(popupState)}>
                                  <MenuItem
                                    onClick={() => {
                                      // setselectedData(item);
                                      // setModalDel(true);
                                      popupState.setOpen(false);
                                    }}
                                  >
                                    Edit
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      // setselectedData(item);
                                      // setModalDel(true);
                                      popupState.setOpen(false);
                                    }}
                                  >
                                    Delete
                                  </MenuItem>
                                </Menu>
                              </React.Fragment>
                            )}
                          </PopupState>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </Datatable>
              </Paper>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Composition data={orderDetail} onBack={() => setView("false")} />
          {/* {JSON.stringify(orderDetail)} */}
          {/* <DetailView data={orderDetail} onBack={() => setView("false")} /> */}
        </>
      )}
    </>
  );
}

export default ServiceManagement;
